import React, { useCallback, type MouseEventHandler } from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { useIssueModalActions } from '@atlassian/jira-business-issue-view/src/common/use-issue-modal-actions';
import { ParentViewField } from '@atlassian/jira-issue-field-parent/src/ui/view';
import type { ParentReadProps } from './types';

export const ParentRead = ({ parent }: ParentReadProps) => {
	const { createOpenIssueModalHandler } = useIssueModalActions();

	const handleClick = useCallback<MouseEventHandler>(
		(e) => {
			if (parent == null || parent.key == null) {
				return;
			}
			return createOpenIssueModalHandler({ key: parent.key })(e);
		},
		[createOpenIssueModalHandler, parent],
	);

	return (
		<Box xcss={parentCellStyles}>
			<ParentViewField value={parent} noValueText="" isMobile={false} onClick={handleClick} />
		</Box>
	);
};

const parentCellStyles = xcss({
	maxWidth: '100%',
});
